import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import UploadBtn from './UploadBtn';
import Cookies from 'js-cookie';
import {getURL} from '../../routes';

import 'react-datepicker/dist/react-datepicker.css';

import {
  fetchUserDataAPI,
  fetchPositionList,
  updateUserDataAPI,
  addUserAPI,
  appendUserList,
  updateUserList
} from 'actions/UserActions';

import {
  fetchCompanyList
} from 'actions/CompanyActions';

const DatePickerBtn = ({onClick, value}) => (
  <label  className="btn btn-primary btn-xs" onClick={onClick}>
    選擇日期
  </label>
)

class WorkerInfoModal extends Component {
  state={
    role: 1,
    chiName: "",
    chiNameErr: false,
    porName: "",
    porNameErr: false,
    moMobile: "",
    moMobileErr: false,
    cnMobile: "",
    cnMobileErr: false, 
    beneficiaryID: "",
    nrwID: "",
    nrwIDExpAt: moment().format("YYYY-MM-DD"),
    nrwIDFname: "",
    safetyID: "",
    safetyIDExpAt: moment().format("YYYY-MM-DD"),
    safetyIDFname: "",
    passID: "",
    passIDExpAt: moment().format("YYYY-MM-DD"),
    passIDFname: "",
    companyID: 1,
    status: 0,
    salaryRecords: []
  }

  validator={
    chiName: function (name) {
      let len = name.length;
      return (len === 0 || len > 45)
    },
    porName: function (name) {
      let len = name.length;
      return (len === 0 || len > 45)
    },
    moMobile: function (num) {
      let len = num.length;
      let isNotDigit = isNaN(num)
      return (isNotDigit || len !== 8)
    },
    cnMobile: function (num) {
      let len = num.length;
      let isNotDigit = isNaN(num)
      return (isNotDigit || len > 11)
    },
  }

  componentDidMount() {
    let {selected, mode, dispatch} = this.props;

    dispatch(fetchPositionList());
    dispatch(fetchCompanyList());
    mode === 'EDIT' &&
      fetchUserDataAPI(selected)
        .then((response) => {
          let {data} = response;
          this.setState(data);
        })
        .catch((e) => {
        })
  }

  handleTextChange = (e) => {
    let {name, value} = e.target;
    let newTextState = {[name]: value};
    this.validator[name] && Object.assign(newTextState, {[name + "Err"]: this.validator[name](value)})

    this.setState(newTextState);
  }

  handleSelectChange = (e) => {
    let target = e.target;
    let name = target.name;
    let value = parseInt(target.value, 10);

    this.setState({[name]: value});
  }

  handleDatePicker = (name) => {
    return (date) => {
      this.setState({[name]: date.format("YYYY-MM-DD")})
    }
  }

  handleFname = (name) => {
    return (fname) => {
      this.setState({[name]: fname})
    }
  }

  handleValidForSumbit = () => {
    let invalid = false;
    let newState = {};
    let state = this.state;

    for (let attr in state) {
      this.validator[attr] &&
        Object.assign(newState, {[attr + "Err"]: this.validator[attr](state[attr])})
      invalid = invalid || newState[attr + "Err"];
    }

    return {invalid: invalid, newState: newState}
  }

  handleUpdateUser = () => {
    let {invalid, newState} = this.handleValidForSumbit();

    if (!invalid) {
      let {selected, dismissModal, dispatch} = this.props;
      let {chiName, role, status} = this.state;
      updateUserDataAPI({uid: selected, ...this.state})
        .then((response) => {
          dispatch(updateUserList(selected, chiName, role, status))
          dismissModal();
        })
        .catch((e) => {
          alert("存儲失敗")
        })
    } else {
      this.setState(newState);
    }
  }

  handleCreateUser = () => {
    let {invalid, newState} = this.handleValidForSumbit();

    if (!invalid) {
      let {selected, dismissModal, dispatch} = this.props;
      let {chiName, role, status} = this.state;
      addUserAPI({uid: selected, ...this.state})
        .then((response) => {
          let {uid} = response.data;
          uid > 0 && dispatch(appendUserList(uid, chiName, role, status))
          dismissModal();
        })
        .catch((e) => {
          alert("存儲失敗")
        })
    } else {
      this.setState(newState);
    }
  }

  render() {
    let {dismissModal, mode, positionList, companyList} = this.props;
    let {
      chiName, chiNameErr, porName, porNameErr,
      moMobile, moMobileErr, cnMobile, cnMobileErr,
      nrwID, nrwIDExpAt, nrwIDFname, beneficiaryID,
      safetyID, safetyIDExpAt, safetyIDFname,
      passID, passIDExpAt, passIDFname, companyID,
      role, status, salary, salaryRecords
    } = this.state;
    let token = Cookies.get('sx');

    return (
      <Modal.Dialog className="user-info-panel">
        <Modal.Header>
          <Modal.Title>
            用戶資料
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form-horizontal">
            <div className={"form-group" + (chiNameErr? " has-error" : "")} >
              <label className="col-sm-2 control-label">中文姓名</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="chiName"
                  value={chiName}
                  onChange={this.handleTextChange}
                  className="form-control" />
              </div>
            </div>
            <div className={"form-group" + (porNameErr? " has-error" : "")}>
              <label className="col-sm-2 control-label">英文姓名</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="porName"
                  value={porName}
                  onChange={this.handleTextChange}
                  className="form-control" />
                <p className="help-block">預設為登入帳號</p>
              </div>
            </div>

            <div className={"form-group" + (moMobileErr? " has-error" : "")}>
              <label className="col-sm-2 control-label">澳門電話</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="moMobile"
                  value={moMobile}
                  onChange={this.handleTextChange}
                  className="form-control" />
                <p className="help-block">預設為登入密碼</p>
              </div>
            </div>

            <div className={"form-group" + (cnMobileErr? " has-error" : "")}>
              <label className="col-sm-2 control-label">大陸電話</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="cnMobile"
                  value={cnMobile}
                  onChange={this.handleTextChange}
                  className="form-control" />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">社保編號</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="beneficiaryID"
                  value={beneficiaryID || ""}
                  onChange={this.handleTextChange}
                  className="form-control" />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">藍卡</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="nrwID"
                  value={nrwID || ""}
                  onChange={this.handleTextChange}
                  className="form-control" />
              </div>
              {mode === 'EDIT' &&
                <div className="col-sm-offset-2 col-sm-4 file-upload">
                  {nrwIDFname && <a target="_blank" href={getURL('/api/upload/') + nrwIDFname + "?sx=" + token}>瀏覽附件</a>}
                  {" "}
                  <UploadBtn
                    label={(nrwIDFname? "重新上載(.pdf)" : "上載附件(.pdf)")}
                    handleFname={this.handleFname("nrwIDFname")}
                    />
                </div>
              }
              <label className={(mode !== 'EDIT'? "col-sm-offset-6 " : "" ) + "col-sm-2 control-label"}>
                有效期至
              </label>
              <div className="col-sm-4  date-picker">
                {(nrwIDExpAt ? nrwIDExpAt : moment().format("YYYY-MM-DD"))}
                {" "}
                <DatePicker
                  customInput={<DatePickerBtn />}
                  selected={moment(nrwIDExpAt)}
                  onChange={this.handleDatePicker("nrwIDExpAt")} />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">職安卡</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="safetyID"
                  value={safetyID || ""}
                  onChange={this.handleTextChange}
                  className="form-control" />
              </div>
              {mode === 'EDIT' &&
                <div className="col-sm-offset-2 col-sm-4 file-upload">
                  {safetyIDFname && <a target="_blank" href={getURL('/api/upload/') + safetyIDFname + "?sx=" + token}>瀏覽附件</a>}
                  {" "}
                  <UploadBtn
                    label={(safetyIDFname? "重新上載(.pdf)" : "上載附件(.pdf)")}
                    handleFname={this.handleFname("safetyIDFname")}
                    />
                </div>
              }
              <label className={(mode !== 'EDIT'? "col-sm-offset-6 " : "" ) + "col-sm-2 control-label"}>
                有效期至
              </label>
              <div className="col-sm-4  date-picker">
                {(safetyIDExpAt ? safetyIDExpAt : moment().format("YYYY-MM-DD"))}
                {" "}
                <DatePicker
                  customInput={<DatePickerBtn />}
                  selected={(safetyIDExpAt ? moment(safetyIDExpAt) : moment())}
                  onChange={this.handleDatePicker("safetyIDExpAt")} />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">通行證</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  name="passID"
                  value={passID || ""}
                  onChange={this.handleTextChange}
                  className="form-control" />
              </div>
              {mode === 'EDIT' &&
                <div className="col-sm-offset-2 col-sm-4 file-upload">
                  {passIDFname && <a target="_blank" href={getURL('/api/upload/') + passIDFname + "?sx=" + token}>瀏覽附件</a>}
                  {" "}
                  <UploadBtn
                    label={(passIDFname? "重新上載(.pdf)" : "上載附件(.pdf)")}
                    handleFname={this.handleFname("passIDFname")}
                    />
                </div>
              }
              <label className={(mode !== 'EDIT'? "col-sm-offset-6 " : "" ) + "col-sm-2 control-label"}>
                有效期至
              </label>
              <div className="col-sm-4  date-picker">
                {(passIDExpAt ? passIDExpAt : moment().format("YYYY/MM/DD"))}
                {" "}
                <DatePicker
                  customInput={<DatePickerBtn />}
                  selected={(passIDExpAt ? moment(passIDExpAt) : moment())}
                  onChange={this.handleDatePicker("passIDExpAt")} />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">隸屬公司</label>
              <div className="col-sm-10">
                <select
                  name="companyID"
                  value={companyID}
                  onChange={this.handleSelectChange}
                  className="form-control" >
                  {companyList.map(company => (
                    <option value={company.get('id')}>
                      {company.get('name')}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">類型</label>
              <div className="col-sm-10">
                <select
                  name="role"
                  value={role}
                  onChange={this.handleSelectChange}
                  className="form-control" >
                  {positionList
                    .filter(p => p.get('type') == 0)
                    .map(position => (
                      <option value={position.get('id')}>
                        {position.get('name')}
                      </option>
                    ))
                  }
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2 control-label">狀態</label>
              <div className="col-sm-10">
                <select
                  name="status"
                  value={status}
                  onChange={this.handleSelectChange}
                  className="form-control" >
                  <option value={0}>在職</option>
                  <option value={1}>離職</option>
                </select>
              </div>
            </div>

            {(salary &&
              <div className="form-group">
                <label className="col-sm-2 control-label">現時薪金</label>
                <label className="col-sm-4 label-content">
                  ${salary}/工
                </label>
                {(salaryRecords.length > 0 &&
                  <label className="col-sm-2 control-label">
                    調整記錄
                  </label>
                )}

                {(salaryRecords.length > 0 &&
                  salaryRecords.map((record, index) => (
                    <label className={"col-sm-4 label-content" + (index === 0 ? "":" col-sm-offset-8")}>
                      ${record.amount} 於 {record.date} 生效
                    </label>
                  ))
                )}
              </div>
            )}
          </form>
        </Modal.Body>
        <Modal.Footer>
          {(mode === "EDIT"
            ? <button
                className="btn btn-primary"
                onClick={this.handleUpdateUser} >
                存儲
              </button>
            : <button
                className="btn btn-primary"
                onClick={this.handleCreateUser} >
                新增
              </button>)}
          <button
            className="btn btn-default"
            onClick={dismissModal}>
            關閉
          </button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}

export default WorkerInfoModal;



// WEBPACK FOOTER //
// ./src/components/Worker/WorkerInfoModal.js